import { render } from "./StandardsChart.vue?vue&type=template&id=7726be77&scoped=true"
import script from "./StandardsChart.vue?vue&type=script&lang=js"
export * from "./StandardsChart.vue?vue&type=script&lang=js"

import "./StandardsChart.vue?vue&type=style&index=0&id=7726be77&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7726be77"]])

export default __exports__